import moment from 'moment'

import constants from 'constants/index'

const findConflictingActiveAudit = (audits, startDate) => {
  if (!startDate || !audits?.length) return null

  const { COMPLETED_PROGRESS_STATUS, INACTIVE_STATUS } =
    constants.companySuppliers
  const start = moment(startDate)

  return (
    audits.find(
      (audit) =>
        audit?.progressStatus !== COMPLETED_PROGRESS_STATUS &&
        audit?.status !== INACTIVE_STATUS &&
        audit?.endDate &&
        start.isSameOrBefore(moment(audit.endDate), 'day'),
    ) || null
  )
}

export default findConflictingActiveAudit
